
<template>
  <div>
    <b-card-header class="p-1" header-bg-variant="white">
      <b-row>
        <b-col sm="12" lg="6">
          <img src="@/icon/2448909.png" class="img-rounded img-responsive" style="width: 1.5em;" />
        </b-col>
        <b-col sm="12" lg="6" style="text-align: right;"><!-- 
          <b-button style="margin-right: 5px; padding: 0px;" variant="secondary" title="sola ilerle" size="sm" @click="f_moveChartData('', 'left')">
            <img src="@/icon/1277677.png" style="width: 2em;" />
          </b-button>
          <b-button style="margin-right: 5px; padding: 0px;" variant="secondary" title="sağa ilerle" size="sm" @click="f_moveChartData('', 'right')">
            <img src="@/icon/1277676.png" style="width: 2em;" />
          </b-button>
          <b-button style="margin-right: 5px; padding: 0px;" variant="secondary" title="tümünü göster" size="sm" @click="f_moveChartData('', 'all')">
            <img src="@/icon/453632.png" style="width: 2em;" />
          </b-button>
          <b-button style="margin-right: 5px; padding: 0px;" variant="secondary" title="reset" size="sm" @click="f_moveChartData('', 'reset')">
            <img src="@/icon/937437.png" style="width: 2em;" />
          </b-button>
         --></b-col>
      </b-row>
    </b-card-header>
    <b-row>
      <b-col cols="12">
        <b-card no-body>
          <template v-for="(report, report_index) in p_analyzeReports">
            <template v-if="report && report.data && report.data['0']">
              <template v-if="report.data['0']['2'] && report.data['0']['2']['val']">
                <template v-if="report.data['0']['2']['val']['value'] === '1'">
                  <b-row style="margin: 0px;">
                    <b-col sm="12" lg="12" style="padding: 3px;">
                      <b-card no-body bg-variant="whitey">
                        <b-row style="margin: 0px;">
                          <b-col cols="8" style="padding: 10px;">
                            <b-button v-if="p_isEligibleSelect" style="margin-right: 5px;" size="sm" variant="white" @click="f_changeSelectedListItem(report.client_id)">
                              <i :class="f_calculateIcon(report.client_id)"></i>
                            </b-button>
                          
                            <strong style="color: #7e0303;">
                              {{ report['label'].toLocaleUpperCase() }}
                            </strong>
                            
                            <small v-if="report['data']['0']['24'] && report['data']['0']['24']['val']" style="color: #03477e;">
                              {{ ' [' }}{{ report['data']['0']['24']['val'].toLocaleUpperCase() }}]
                            </small>
                          </b-col>
                          <b-col cols="4" style="padding: 10px; font-size: 16px;">
                            <strong>{{ report.data['0']['6']['val'] }}</strong>
                          </b-col>
                        </b-row>
                      </b-card>
                    </b-col>
                  </b-row>
                </template>
              </template>
            </template>
          </template>
          <template v-for="(report, report_index) in p_analyzeReports">
            <template v-if="report && report.data && report.data['0']">
              <template v-if="report.data['0']['2'] && report.data['0']['2']['val']">
                <template v-if="report.data['0']['2']['val']['value'] === '2'">
                  <b-row style="margin: 0px;">
                    <b-col sm="12" lg="12" style="padding: 3px;">
                      <b-card no-body bg-variant="whitey">
                        <b-row style="margin: 0px;">
                          <b-col cols="8" style="padding: 10px;">
                            <b-button v-if="p_isEligibleSelect" style="margin-right: 5px;" size="sm" variant="white" @click="f_changeSelectedListItem(report.client_id)">
                              <i :class="f_calculateIcon(report.client_id)"></i>
                            </b-button>
                          
                            <strong style="color: #7e0303;">
                              {{ report['label'].toLocaleUpperCase() }}
                            </strong>
                            
                            <small v-if="report['data']['0']['24'] && report['data']['0']['24']['val']" style="color: #03477e;">
                              {{ ' [' }}{{ report['data']['0']['24']['val'].toLocaleUpperCase() }}]
                            </small>
                          </b-col>
                          <b-col cols="4" style="padding: 10px; font-size: 16px;">
                            <strong>{{ report.data['0']['7']['val'] }}</strong>
                          </b-col>
                        </b-row>
                      </b-card>
                    </b-col>
                  </b-row>
                </template>
              </template>
            </template>
          </template>
          <template v-for="(report, report_index) in p_analyzeReports">
            <template v-if="report && report.data && report.data['0']">
              <template v-if="report.data['0']['2'] && report.data['0']['2']['val']">
                <template v-if="report.data['0']['2']['val']['value'] === '0'">
                  <b-row :key="'chart_' + report_index" v-if="report.data['0']['2'] && report.data['0']['2']['val'] && report.data['0']['2']['val']['value']" style="margin: 0px;">
                    <b-col sm="12" lg="12" style="padding: 3px;">
                      <b-card no-body>
                        <b-card-header class="p-1" header-bg-variant="white" style="padding: 10px !important;">
                          <b-row style="margin: 0px;">
                            <b-col cols="9" style="padding: 0px;">
                            <b-button v-if="p_isEligibleSelect" style="margin-right: 5px;" size="sm" variant="white" @click="f_changeSelectedListItem(report.client_id)">
                              <i :class="f_calculateIcon(report.client_id)"></i>
                            </b-button>
                          
                              <strong style="color: #7e0303;">
                                {{ report['label'].toLocaleUpperCase() }}
                              </strong>                            
                            
                              <small v-if="report['data']['0']['24'] && report['data']['0']['24']['val']" style="color: #03477e;">
                                {{ ' [' }}{{ report['data']['0']['24']['val'].toLocaleUpperCase() }}]
                              </small>
                            </b-col>
                            <b-col cols="3" style="text-align: right;"><!-- 
                              <b-button style="margin-right: 5px; padding: 0px;" variant="secondary" title="sola ilerle" size="md" @click="f_moveChartData(report_index, 'left')">
                                <img src="@/icon/1277677.png" style="width: 2em;" />
                              </b-button>
                              <b-button style="margin-right: 5px; padding: 0px;" variant="secondary" title="sağa ilerle" size="md" @click="f_moveChartData(report_index, 'right')">
                                <img src="@/icon/1277676.png" style="width: 2em;" />
                              </b-button>
                              <b-button style="margin-right: 5px; padding: 0px;" variant="secondary" title="tümünü göster" size="md" @click="f_moveChartData(report_index, 'all')">
                                <img src="@/icon/453632.png" style="width: 2em;" />
                              </b-button>
                              <b-button style="margin-right: 5px; padding: 0px;" variant="secondary" title="tümünü göster" size="md" @click="f_moveChartData(report_index, 'reset')">
                                <img src="@/icon/937437.png" style="width: 2em;" />
                              </b-button>
                             --></b-col>
                          </b-row>
                        </b-card-header>
                        <template v-if="report.data['0']['8']['val']['value'] === '0'">
                          <div :style="f_calculateChartStyle(report)">
                            <bar-view v-if="report.show" :height="200" :width="f_calculateChartWidth()" :chartId="'chart_' + report_index.toString()" :chart_data="f_getChartData(report)" />
                          </div>
                        </template>
                        <template v-if="report.data['0']['8']['val']['value'] === '1'">
                          <div :style="f_calculateChartStyle(report)">
                            <doughnut v-if="report.show" -view :height="200" :width="200" :chartId="'chart_' + report_index.toString()" :chart_data="f_getChartData(report)" />
                          </div>
                        </template>
                        <template v-if="report.data['0']['8']['val']['value'] === '2'">
                          <div :style="f_calculateChartStyle(report)">
                            <line-view v-if="report.show" :height="200" :width="f_calculateChartWidth()" :chartId="'chart_' + report_index.toString()" :chart_data="f_getChartData(report)" />
                          </div>
                        </template>
                        <template v-if="report.data['0']['8']['val']['value'] === '3'">
                          <div :style="f_calculateChartStyle(report)">
                            <bar-view v-if="report.show" :height="200" :width="200" :chartId="'chart_' + report_index.toString()" :chart_data="f_getChartData(report)" />
                          </div>
                        </template>
                      </b-card>
                    </b-col>
                  </b-row>
                </template>
              </template>
            </template>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import PieView from '@/components/chart/PieView';
import LineView from '@/components/chart/LineView';
import ScatterView from '@/components/chart/ScatterView';
import BarView from '@/components/chart/BarView';
import DoughnutView from '@/components/chart/DoughnutView';
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
  name: 'AnalyzeReportView',
  computed: mapGetters({
    StoreLang: 'StoreLang',
    StoreLangTranslation: 'StoreLangTranslation',
  }),
  props: {
    p_analyzeReports: {
      type: Array,
      required: true
    },
    p_isEligibleSelect: {
      type: Boolean,
      required: false
    },
  },
  components: {
    LineView,
    ScatterView,
    BarView,
    DoughnutView,
    PieView
  },
  data () {
    return {
      d_timerControlProjectUpdate: { 'timer': 0 },
      d_totalCountPriorityReportOrder: ['totalcount_total_marketing_revenue', 'totalcount_total_primary_marketing_revenue', 'totalcount_total_secondary_marketing_revenue', 'totalcount_protocolopen', 'totalcount_primary_protocolopen', 'totalcount_secondary_protocolopen', 'totalcount_appointment', 'totalcount_primary_appointment', 'totalcount_secondary_appointment'],
      d_reportType: {
        'selected': '',
        'list': [{
          "value": "chart",
          "label": "grafik"
        }, {
          "value": "total_count",
          "label": "toplam adet"
        }, {
          "value": "percent",
          "label": "yüzde"
        }, {
          "value": "",
          "label": "hepsi"
        }]
      },
      d_reportNameType: {
        'selected': '',
        'list': [{
          "value": "selectable",
          "label": "seçilebilir"
        }, {
          "value": "manuel",
          "label": "manuel"
        }, {
          "value": "",
          "label": "hepsi"
        }]
      },
      d_selectedClientIdList: [],
    };
  },
  created: function () {
    this.d_selectedClientIdList = JSON.parse(localStorage.getItem('selected_report_cl_id_list')) || [];
    for (let report_index in this.p_analyzeReports) {
      this.p_analyzeReports[report_index].start = 0;
      this.p_analyzeReports[report_index].show = true;
      this.p_analyzeReports[report_index].end = 1000000;
      this.p_analyzeReports[report_index].max_show_point = 50;
      try {
        this.p_analyzeReports[report_index].start = this.p_analyzeReports[report_index].data['0']['9'].list.length - this.p_analyzeReports[report_index].max_show_point;
        this.p_analyzeReports[report_index].end = this.p_analyzeReports[report_index].data['0']['9'].list.length;
      } catch (err) {}
    }
  },
  mounted: function () {
  },
  destroyed () {},
  methods: {
    f_changeSelectedListItem: function (cl_id) {
      if (this.d_selectedClientIdList.indexOf(cl_id) === -1) {
        this.d_selectedClientIdList.push(cl_id);
        localStorage.setItem('selected_report_cl_id_list', JSON.stringify(this.d_selectedClientIdList));
      } else {
        let index = this.d_selectedClientIdList.indexOf(cl_id)
        this.d_selectedClientIdList.splice(index, 1);
        localStorage.setItem('selected_report_cl_id_list', JSON.stringify(this.d_selectedClientIdList));
      }
    },
    f_calculateIcon: function (cl_id) {
      if (this.d_selectedClientIdList.indexOf(cl_id) === -1) {
        return 'fa fa-star-o'
      } else {
        return 'fa fa-star'
      }
    },
    f_openCloseChart: function (report_index) {
      this.p_analyzeReports[report_index].show = false;
      this.$forceUpdate();
      setTimeout(function () {
        this.p_analyzeReports[report_index].show = true;
        this.$forceUpdate();
      }.bind(this), 5);
    },
    f_moveChartData: function (report_index='', direction='') {
      if (report_index !== '') {
        if (direction === 'right') {
          if (this.p_analyzeReports[report_index].end < this.p_analyzeReports[report_index].data['0']['9'].list.length) {
            this.p_analyzeReports[report_index].start += 1;
            this.p_analyzeReports[report_index].end += 1;
            this.f_openCloseChart(report_index);
          }
        } else if (direction === 'left') {
          if (this.p_analyzeReports[report_index].start !== 0) {
            this.p_analyzeReports[report_index].start -= 1;
            this.p_analyzeReports[report_index].end -= 1;
            this.f_openCloseChart(report_index);
          }
        } else if (direction === 'all') {
          this.p_analyzeReports[report_index].start = 0;
          this.p_analyzeReports[report_index].end = 10000000;
          this.f_openCloseChart(report_index);
        } else if (direction === 'reset') {
          this.p_analyzeReports[report_index].start = this.p_analyzeReports[report_index].data['0']['9'].list.length - this.p_analyzeReports[report_index].max_show_point;
          this.p_analyzeReports[report_index].end = this.p_analyzeReports[report_index].data['0']['9'].list.length;
          this.f_openCloseChart(report_index);
        }

      } else {
        for (let i in this.p_analyzeReports) {
          if (direction === 'right') {
            if (this.p_analyzeReports[i].end < this.p_analyzeReports[i].data['0']['9'].list.length) {
              this.p_analyzeReports[i].start += 1;
              this.p_analyzeReports[i].end += 1;
              this.f_openCloseChart(i);
            }
          } else if (direction === 'left') {
            if (this.p_analyzeReports[i].start !== 0) {
              this.p_analyzeReports[i].start -= 1;
              this.p_analyzeReports[i].end -= 1;
              this.f_openCloseChart(i);
            }
          } else if (direction === 'all') {
            this.p_analyzeReports[i].start = 0;
            this.p_analyzeReports[i].end = 10000000;
            this.f_openCloseChart(i);
          } else if (direction === 'reset') {
            this.p_analyzeReports[i].start = this.p_analyzeReports[i].data['0']['9'].list.length - this.p_analyzeReports[i].max_show_point;
            this.p_analyzeReports[i].end = this.p_analyzeReports[i].data['0']['9'].list.length;
            this.f_openCloseChart(i);
          }
        }
      }
    },
    f_calculateChartWidth: function () {
      let width_val = window.innerWidth - 800;
      return width_val;
    },
    f_calculateChartStyle: function (report) {
      // console.log(window.innerWidth);
      let width_px = (window.innerWidth - 800).toString() + 'px';
      let style = 'margin: 10px;';
      if (report.data['0']['8']['val']['value'] === 'bar') {
        style += 'height: 200px; width: ' + width_px + ';';
      } else if (report.data['0']['8']['val']['value'] === 'line') {
        style += 'height: 200px; width: ' + width_px + ';';
      } else if (report.data['0']['8']['val']['value'] === 'doughnut') {
        style += 'height: 200px; width: 200px;';
      } else if (report.data['0']['8']['val']['value'] === 'pie') {
        style += 'height: 200px; width: 200px;';
      }
      return style;
    },
    f_getChartData: function (report) {
      let chart_data_label_list = [];
      let dataset_list = [];
      try {
        for (let i in report.data['0']['9'].list) {
          if (parseInt(i) >= report.start && parseInt(i) <= report.end) {
            chart_data_label_list.push(report.data['0']['9'].list[i]['10'].val);
          }
        }
      } catch (err) {}
      try {
        for (let i in report.data['0']['11'].list) {
          let new_dataset = {
            'data': [],
            'backgroundColor': [],
            'label': report.data['0']['11'].list[i]['12'].val
          };
          if (report.data['0']['8']['val']['value'] === 'line') {
            new_dataset.lineTension = 0;
            new_dataset.showLine = true;
          }
          try {
            for (let k in report.data['0']['11'].list[i]['13'].list) {
              if (parseInt(k) >= report.start && parseInt(k) <= report.end) {
                let data_value = parseFloat(report.data['0']['11'].list[i]['13'].list[k]['14'].val);
                new_dataset.data.push(data_value);
                let backgroundColor = report.data['0']['11'].list[i]['13'].list[k]['15'].val;
                new_dataset.backgroundColor.push(backgroundColor);
              }
            }
          } catch (err) {}
          // dataset hazırlandıktan sonra liste içerisine ekleniyor.
          dataset_list.push(new_dataset);
        }
      } catch (err) {}
      /*
        {
          "chart_data": {
            "labels": ['SMS % ', 'Mail % ', 'Push % ', 'Telefon ile arama % ', 'Web Push % '],
            "datasets": [{
              "data": [20, 30, 30, 10, 10],
              "backgroundColor": ['rgba(0,28,73,10)', 'rgba(69,75,10,10)', 'rgba(49,73,91,10)', 'rgba(75,91,84,10)', 'rgba(70,52,75,10)'],
              "label": "Kanal operasyonu yüzdeleri"
            }]
          }
        }
      */
      let chart_data = {
        backgroundColor: "#fff",
        labels: chart_data_label_list,
        datasets: dataset_list
      };
      /*
        datasets: [{
          label: caption,
          lineTension: 0,
          borderColor: '#20a8d8',
          backgroundColor: '#ffffff00',
          showLine: true,
          // backgroundColor: hexToRgba('#20a8d8', 90),
          data: []
        }]
      */
      return chart_data;
    },
  },
  watch: {
    'p_analyzeReports.length': function () {
      this.d_selectedClientIdList = JSON.parse(localStorage.getItem('selected_report_cl_id_list')) || [];
    }
  }
};

</script>

<style type="text/css">

</style>

